import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import { createApiInstance } from '../../../config/api';
import { checktoken } from '../../CommonFunc/common.js';
import ProfileView from '../ProfileView';
import Subscriptions from './Subscriptions.js';
import './App.css';

class MyProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      loading: true,
      error: false,
    };
  }

  componentDidMount() {
    checktoken();
    let currentUser = null;
    try {
      const raw = localStorage.getItem('user');
      if (raw) currentUser = JSON.parse(raw);
    } catch (e) {
      console.error('Error parsing user:', e);
    }

    if (!currentUser?._id) {
      this.setState({ loading: false });
      return;
    }

    this.fetchProfile(currentUser._id);
  }

  fetchProfile = async (userId) => {
    try {
      const api = createApiInstance();
      const res = await api.get(`/profile/${userId}`);
      this.setState({ user: res.data, loading: false });
    } catch (error) {
      console.error('Error fetching profile:', error);
      this.setState({ loading: false, error: true });
    }
  };

  render() {
    const { user, loading, error } = this.state;

    if (loading) {
      return (
        <div className="mm">
          <ReactLoading style={{ color: "black", margin: "auto", height: "15%", width: "15%" }} type={"spinningBubbles"} />
        </div>
      );
    }

    if (error || !user) {
      return (
        <div className="mm">
          <div className="mm-loading">Could not load your profile. Please log in again.</div>
        </div>
      );
    }

    return (
      <>
        <ProfileView user={user} isOwnProfile />
        <Subscriptions myBenefits={user.myBenefits || []} user_id={user._id} />
      </>
    );
  }
}

export default MyProfile;
